@if (messageStatus() !== 'DISABLED' && showTooltip()) {
  <app-tooltip class="formGroupLabel" placement="top">
    <app-task-message-status-icon [messageStatus]="messageStatus()" [customCssClass]="customCssClass()"></app-task-message-status-icon>
    <span class="d-none d-sm-inline-block">{{sentenceCasePipe() ? (label() || messageStatusLabel() | sentenceCase) : label() || messageStatusLabel()}}</span>
    <div class="tooltipContent text-start">
      <span class="d-block fw-bold">{{header()}}</span>
      <span class="d-block">{{reason()}}</span>
    </div>
  </app-tooltip>
} @else if (messageStatus() !== 'DISABLED' && !showTooltip()) {
  <app-task-message-status-icon [messageStatus]="messageStatus()" [customCssClass]="customCssClass()"></app-task-message-status-icon>
  <span class="d-inline-block" [style.min-width.px]="62">{{sentenceCasePipe() ? (label() || messageStatusLabel() | sentenceCase) : label() || messageStatusLabel()}}</span>
}
